import React from 'react'
import useWindowSize from '../../../hooks/useWindowSize'
import DesktopLoader from './DesktopLoader'
import MobileLoader from './MobileLoader'

const Loader = () => {
    const { isMobile } = useWindowSize()
    return isMobile ? <MobileLoader /> : <DesktopLoader />
}

export default Loader
